import { InfoTip } from "@/components/ui/InfoTip";
import { glossary, useMaster } from "@/store/master";

/** 용어 도움말 ⓘ , 마스터의 glossary 항목(ISO 14040,14044 근거)을 풍선으로 */
export function GlossaryTip({ k }: { k: string }) {
  const data = useMaster((s) => s.data);
  const g = glossary(data, k);
  if (!g) return null;
  return (
    <InfoTip label={`${g.term} 설명`}>
      <b className="text-ink">{g.term}</b>
      {g.termEn && <span className="text-ink-subtle"> ({g.termEn})</span>}
      <br />
      {g.definition}
      <br />
      <span className="text-ink-subtle">출처: {g.source}</span>
    </InfoTip>
  );
}
